import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const addTrackedBrands = async (pageIds = []) => {
  const token = await firebase.auth().currentUser?.getIdToken()

  const { data } = await AxiosConfig.post(
    '/spyder/track',
    { pageIds },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

const getTrackedBrands = async () => {
  const token = await firebase.auth().currentUser?.getIdToken()
  const { data } = await AxiosConfig.get(
    '/spyder/tracked-brands',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

const checkSpyderOverage = async () => {
  const token = await firebase.auth().currentUser?.getIdToken()
  const { data } = await AxiosConfig.get(
    '/spyder/overage',
    { headers: { Authorization: `Bearer ${token}` } }
  )
  return data
}

// pageRemovals [] { pageId: string, folderId: string | null}
const removeTrackedBrands = async (pageRemovals = []) => {
  const token = await firebase.auth().currentUser?.getIdToken()
  const { data } = await AxiosConfig.delete(
    '/spyder/track',
    {
      data: { pageRemovals },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

const getBrandPreview = async (pageId) => {
  const user = await firebase.auth().currentUser
  const authToken = await user.getIdToken()

  const { data } = await AxiosConfig.get(
    `/spyder/preview/${pageId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    }
  )
  return data
}

export default {
  addTrackedBrands,
  getTrackedBrands,
  removeTrackedBrands,
  checkSpyderOverage,
  getBrandPreview
}
